import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./simpleDate.scss";
import dayjs from "dayjs";
import { StaticDatePicker } from "@mui/x-date-pickers";
import { useState } from "react";

const DatePickerComponent = (props: any) => {
  const { format, staticPicker } = props;
  const [open, setOpen] = useState(false);
  const defaultDateFormat = process.env.REACT_APP_DEFAULT_DATE_FORMAT;
  return (
    <div className="margin-up-12">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {!staticPicker ? (
          <DesktopDatePicker
            open={open}
            onClose={() => setOpen(false)}
            sx={{ height: "40px", marginTop: "-5px" }}
            slotProps={{
              textField: {
                onClick: () => setOpen(true),
                onKeyDown: (e: any) => {
                  e.preventDefault();
                },
              },
            }}
            className={
              "full simple-date " +
              (props.disabled ? "date-picker-disabled" : "date-picker-enabled")
            }
            value={props.value || null}
            onChange={props.onChange}
            format={format || defaultDateFormat}
            views={props.views}
            disabled={props.disabled}
            disableFuture={props.disableFuture}
            disablePast={props.disablePast}
            minDate={props.minDate ? dayjs(props.minDate) : null}
            maxDate={props.maxDate ? dayjs(props.maxDate) : null}
          />
        ) : (
          <StaticDatePicker
            defaultValue={props.value}
            onChange={props.onChange}
            disableFuture={props.disableFuture}
          />
        )}
      </LocalizationProvider>
    </div>
  );
};

export default DatePickerComponent;
